import {
  ScrollView,
  Text,
  ThemeableStack,
  XStack,
  styled,
  withStaticProperties,
} from 'tamagui';

/** Table Components */
const Row = styled(ThemeableStack, {
  tag: 'tr',
  flexDirection: 'row',
  variants: {
    selected: {
      true: {
        backgroundColor: '$primary5',
      },
    },
  },
});

const Cell = styled(Text, {
  tag: 'td',
  flexDirection: 'row',
  flexShrink: 0,
  flexBasis: 'auto',
  fontFamily: '$body',
  fontSize: '$2',
  padding: '$4',
  minWidth: 0,
});

export const HeaderCell = styled(Text, {
  tag: 'th',
  flexDirection: 'row',
  display: 'flex',
  fontFamily: '$body',
  fontSize: '$2',
  paddingHorizontal: '$4',
  minHeight: 40,
  flexShrink: 0,
  flexBasis: 'auto',
  alignItems: 'center',
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const TBody = styled(ThemeableStack, {
  tag: 'tbody',
  flexDirection: 'column',
  flexShrink: 1,
});

const THead = styled(XStack, {
  tag: 'thead',
  flexDirection: 'column',
  flexShrink: 1,
  borderBottomWidth: 1,
  borderBottomColor: '$secondary25',
});

const TFoot = styled(ThemeableStack, {
  tag: 'tfoot',
  flexDirection: 'column',
  flexShrink: 1,
});

const TableScrollContainer = styled(ScrollView, {
  horizontal: true,
  showsHorizontalScrollIndicator: true,
  backgroundColor: '$tertiary25',
  contentContainerStyle: {
    minWidth: '100%',
  },
});

const TableComp = styled(ThemeableStack, {
  tag: 'table',
  flexDirection: 'column',
  minWidth: '100%',
});

export const StyledTable = withStaticProperties(TableScrollContainer, {
  Table: TableComp,
  Head: THead,
  Body: TBody,
  Row,
  Cell,
  HeaderCell,
  Foot: TFoot,
});
